import classNames from 'classnames';
import { useContext } from 'react';

import TableContext from '../table/table-context';

export interface TableHeadCellProps
  extends Omit<
    React.DetailedHTMLProps<React.ThHTMLAttributes<HTMLTableHeaderCellElement>, HTMLTableHeaderCellElement>,
    'align'
  > {
  className?: string;
  size?: 'small' | 'medium' | 'xs'; // will also be passed from `Table` component via `TableContext`
  align?: 'inherit' | 'left' | 'right' | 'center' | 'justify';
}

export function TableHeadCell({
  className,
  children,
  size: sizeProp,
  align = 'left',
  ...otherProps
}: React.PropsWithChildren<TableHeadCellProps>) {
  const table = useContext(TableContext);
  const { size }: TableHeadCellProps = {
    size: sizeProp || table?.size || 'medium',
  };

  return (
    <th
      {...otherProps}
      className={classNames(
        size === 'medium' && ['px-3 py-3', 'text-xs', 'font-semibold'],
        size === 'small' && ['px-1 py-2', 'text-xs'],
        size === 'xs' && ['px-1 py-2 first:pl-4 last:pr-4', 'text-xs'],
        align === 'inherit' && '[text-align:inherit]',
        align === 'left' && 'text-left',
        align === 'right' && 'text-right',
        align === 'center' && 'text-center',
        align === 'justify' && 'text-justify',
        'whitespace-nowrap text-[#dadada] dark:text-[#dadada] font-normal text-left text-ellipsis overflow-hidden',
        className,
      )}
    >
      {children}
    </th>
  );
}

export default TableHeadCell;
